<mat-chip
  [attr.data-testid]="dataTestId()"
  [disabled]="isDisabled()"
  [highlighted]="isHighlighted()"
  [tabIndex]="isDisabled() ? -1 : 0"
  (click)="this.clicked.emit()"
  (keydown.enter)="this.clicked.emit()"
  class="custom-chip">
  @if (avatarIcon()) {
    <mat-icon matChipAvatar [svgIcon]="avatarIcon()!" />
  }
  {{ title() }}
</mat-chip>
